export default "__VITE_ASSET__a12b725c__"